import * as $ from 'jquery'

import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule, Routes, ExtraOptions } from '@angular/router'
import { provideAnimations } from '@angular/platform-browser/animations';

import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch'
import { InputTextareaModule } from 'primeng/inputtextarea'
import { MenuModule } from 'primeng/menu';
import { MultiSelectModule } from 'primeng/multiselect';
import { PasswordModule } from 'primeng/password';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TagModule } from 'primeng/tag'
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TooltipModule } from 'primeng/tooltip';
import { DividerModule } from 'primeng/divider';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { SidebarModule } from 'primeng/sidebar';
import { BurtUiModule } from '@burt-ui';

import { COMPONENTS, ENTRY_COMPONENTS } from './components/components';
import { SERVICES } from './services/providers';

import { WrapMiddleDirective } from './directives/wrap-middle.directive'

import { PIPES } from './pipes/providers'

import {
  DateRangePickerModule,
  HubUrlModule,
  LocationModule,
  WindowModule
} from './modules'

import {
  EmailListValidator,
} from './validators/email-list.validator';

import { UnsavedChangesGuard } from './guards/unsaved-changes.guard'
import { DropdownModule } from 'primeng/dropdown'
import { DialogTemplateComponent } from './components/dialog-template/dialog-template.component'
import { HubTemplateSaveModalModule } from './components/template-save-modal/template-save-modal.module';
import { InputTextModule } from 'primeng/inputtext'

const HUB_MODULES = [
  CommonModule,
  DateRangePickerModule,
  FormsModule,
  ReactiveFormsModule,
  // HttpModule,
  HttpClientModule,
  RouterModule,
  BurtUiModule,
  HubUrlModule,
  LocationModule,
  WindowModule,
  DropdownModule,
  DialogModule,
  ButtonModule,
  TooltipModule,
  SidebarModule,
  AvatarModule,
  PanelMenuModule,
  DividerModule,
  PanelModule,
  CardModule,
  MenuModule,
  HubTemplateSaveModalModule,
  DialogTemplateComponent,
  ToggleButtonModule,
  SelectButtonModule,
  MultiSelectModule,
  InputTextareaModule,
  CheckboxModule,
  InputSwitchModule,
  InputTextModule,
  PasswordModule,
  TagModule,
]

const HUB_COMPONENTS = [
  COMPONENTS,
  EmailListValidator,
  WrapMiddleDirective
]

const HUB_PIPES = [
  PIPES
]

const HUB_SERVICES = [
  SERVICES
]

const HUB_GUARDS = [
  UnsavedChangesGuard
]

@NgModule({
  declarations: [
    HUB_COMPONENTS,
    HUB_PIPES,
  ],
  imports: [
    HUB_MODULES,
  ],
  exports: [
    HUB_MODULES,
    HUB_COMPONENTS,
    HUB_PIPES,
  ],
  providers: []
})
export class HubComponentsModule {
  public static forRoot(): ModuleWithProviders<HubComponentsModule> {
    return { ngModule: HubComponentsModule, providers: [HUB_SERVICES, HUB_GUARDS, provideAnimations()] };
  }
}
